var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1008_284)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.094 18.531C11.8206 18.2575 11.667 17.8867 11.667 17.5C11.667 17.1133 11.8206 16.7424 12.094 16.4689L20.3438 8.21914C20.4783 8.07985 20.6392 7.96875 20.8171 7.89232C20.9951 7.81589 21.1864 7.77566 21.3801 7.77398C21.5737 7.7723 21.7657 7.8092 21.9449 7.88252C22.1242 7.95585 22.287 8.06414 22.4239 8.20106C22.5608 8.33799 22.6691 8.50081 22.7425 8.68004C22.8158 8.85926 22.8527 9.05129 22.851 9.24493C22.8493 9.43857 22.8091 9.62993 22.7327 9.80785C22.6562 9.98577 22.5451 10.1467 22.4058 10.2812L15.1871 17.5L22.4058 24.7187C22.6715 24.9938 22.8185 25.3621 22.8152 25.7445C22.8118 26.1269 22.6585 26.4927 22.3881 26.763C22.1177 27.0334 21.7519 27.1868 21.3696 27.1901C20.9872 27.1934 20.6188 27.0465 20.3438 26.7808L12.094 18.531Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1008_284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLine);
export default __webpack_public_path__ + "static/media/left_line.a38a91cbf90c6b6758da0a6c56586a30.svg";
export { ForwardRef as ReactComponent };